import request from '@/utils/request'

export function bind(params) {
    return request({
        url: '/cloudpen/bindPen',
        method: 'post',
        data: params
    })
}

export function getWaitBindList() {
    return request({
        url: '/cloudpen/getUserNotAllowPen',
        method: 'get'
    })
}

export function changeCurrentPcrId(id) {
    return request({
        url: '/index/changeCurrentPcrId',
        method: 'post',
        params: {
            id: id
        }
    })
}

export function getFamily() {
    return request({
        url: '/user/getFamily',
        method: 'get'
    })
}

export function getFamily2() {
    return request({
        url: '/user/getFamily2',
        method: 'get'
    })
}

export function stat() {
    return request({
        url: '/cloudpen/stat',
        method: 'get'
    })
}

export function unBind(params) {
    return request({
        url: '/cloudpen/unbind',
        method: 'post',
        params: params
    })
}

export function getApply() {
    return request({
        url: '/user/getOneInvalidUser',
        method: 'get',
    })
}

export function acceptApply(params) {
    return request({
        url: '/user/audit',
        method: 'post',
        data: params
    })
}

export function editEquipmentInfo(params) {
    return request({
        url: '/cloudpen/editEquipmentInfo',
        method: 'post',
        data: params
    })
}

export function callPhone() {
    return request({
        url: '/user/callPhone',
        method: 'get'
    })
}

export function alterPhone(phone) {
    return request({
        url: '/user/alterPhone',
        method: 'get',
        params: {
            phone
        }
    })
}

export function getPhoneLogList() {
    return request({
        url: '/user/phoneLog/list',
        method: 'get'
    })
}
export function getApplyCount() {
    return request({
        url: '/user/getInvalidUserCount',
        method: 'get'
    })
}

export function searchPen() {
    return request({
        url: '/cloudpen/search',
        method: 'get'
    })
}

export function getClockList() {
    return request({
        url: '/clock/getClock',
        method: 'get'
    })
}

export function setClock(params) {
    return request({
        url: '/clock/save',
        method: 'post',
        params: params
    })
}

export function switchClock(params) {
    return request({
        url: '/clock/switchClock',
        method: 'post',
        params: params
    })
}

export function deleteContacts(params) {
    return request({
        url: '/user/phoneBook/delete',
        method: 'post',
        params: params
    })
}

export function findContactsList() {
    return request({
        url: '/user/phoneBook/list',
        method: 'get',
    })
}
export function editContacts(params) {
    return request({
        url: '/user/phoneBook/edit',
        method: 'post',
        data: params
    })
}

export function syncContacts(params) {
    return request({
        url: '/user/phoneBook/sync',
        method: 'post',
        data: params
    })
}

export function addContacts(params) {
    return request({
        url: '/user/phoneBook/add',
        method: 'post',
        data: params
    })
}

export function deletePhoneLog(params) {
    return request({
        url: '/user/phoneLog/delete',
        method: 'post',
        params: params
    })
}

export function fetchSignature(params) {
    const wechatName = process.env.WECHAT_NAME;
    if (wechatName === 'yff') {
        return request({
            url: '/WxAuth/fetchSignature',
            method: 'get',
            params: params
        })
    } else if (wechatName === 'x16') {
        return request({
            url: '/x16WxAuth/fetchSignature',
            method: 'get',
            params: params
        })
    }
    
}

export function switchEquiment(params) {
    return request({
        url: '/cloudpen/telSwitch',
        method: 'get',
        params: params
    })
}

export function getBannerList(params) {
    return request({
        url: '/cloudpen/getBannerList',
        method: 'get',
        params: params
    })
}

export function switchStranger(params) {
    return request({
        url: '/cloudpen/telLimitSwitch',
        method: 'get',
        params: params
    })
}

export function getTelSwitch() {
    return request({
        url: '/cloudpen/getTelSwitch',
        method: 'get'
    })
}

export function getStrangerSwitch() {
    return request({
        url: '/cloudpen/getTelLimitSwitch',
        method: 'get'
    })
}


export function getOnlineStatus() {
    return request({
        url: '/cloudpen/getOnlineStatus',
        method: 'get'
    })
}

export function makeOver(params) {
    return request({
        url: '/cloudpen/makeOver',
        method: 'post',
        params: params
    })
}

export function getShareQr(params) {
    return request({
        url: '/cloudpen/getShareQr',
        method: 'post',
        params: params
    })
}
export function getShareQrForever(params) {
    return request({
        url: '/cloudpen/getShareQrForever',
        method: 'post',
        params: params
    })
}

export function getPenInfoByPenNo(params) {
    return request({
        url: '/cloudpen/getPenInfoByPenNo',
        method: 'post',
        params: params
    })
}

export function rechargeCoupon(params) {
    return request({
        url: '/cloudpen/rechargeCoupon',
        method: 'post',
        params: params
    })
}

export function rechargeCouponByElevator(params) {
    return request({
        url: '/cloudpen/rechargeCouponByElevator',
        method: 'post',
        params: params
    })
}

export function getCurrentPenInfo(params) {
    return request({
        url: '/cloudpen/getCurrentPenInfo',
        method: 'post',
        params: params
    })
}
export function setYunPanTips(params) {
    return request({
        url: '/cloudpen/setYunPanTips',
        method: 'post',
        params: params
    })
}

export function toAudit(params) {
    return request({
        url: '/cloudpen/toAudit',
        method: 'post',
        params: params
    })
}

export function createNoScreenUserPen(params) {
    return request({
        url: '/cloudpen/createNoScreenUserPen',
        method: 'post',
        params: params
    })
}

export function getMenuList(params) {
    return request({
        url: '/cloudpen/getMenuList',
        method: 'post',
        params: params
    })
}

export function hasAdminPower(params) {
    return request({
        url: '/cloudpen/hasAdminPower',
        method: 'post',
        params: params
    })
}



// WEBPACK FOOTER //
// ./src/api/pen.js